/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScheduleBlockEntity
 */
export interface ScheduleBlockEntity {
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    id?: string;
    /**
     * 
     * @type {any}
     * @memberof ScheduleBlockEntity
     */
    schedule?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleBlockEntity
     */
    startTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleBlockEntity
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    participantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    status?: ScheduleBlockEntityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    originalBlockId?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    metadata?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    linkedEntityType?: ScheduleBlockEntityLinkedEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    linkedEntityId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleBlockEntity
     */
    lastExecutedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof ScheduleBlockEntity
     */
    executionCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    lastError?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleBlockEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleBlockEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleBlockEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleBlockEntity
     */
    override?: boolean;
}


/**
 * @export
 */
export const ScheduleBlockEntityStatusEnum = {
    Scheduled: 'SCHEDULED',
    Active: 'ACTIVE',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Pending: 'PENDING',
    Failed: 'FAILED'
} as const;
export type ScheduleBlockEntityStatusEnum = typeof ScheduleBlockEntityStatusEnum[keyof typeof ScheduleBlockEntityStatusEnum];

/**
 * @export
 */
export const ScheduleBlockEntityLinkedEntityTypeEnum = {
    None: 'NONE',
    Integration: 'INTEGRATION',
    Action: 'ACTION',
    Workflow: 'WORKFLOW'
} as const;
export type ScheduleBlockEntityLinkedEntityTypeEnum = typeof ScheduleBlockEntityLinkedEntityTypeEnum[keyof typeof ScheduleBlockEntityLinkedEntityTypeEnum];


/**
 * Check if a given object implements the ScheduleBlockEntity interface.
 */
export function instanceOfScheduleBlockEntity(value: object): value is ScheduleBlockEntity {
    return true;
}

export function ScheduleBlockEntityFromJSON(json: any): ScheduleBlockEntity {
    return ScheduleBlockEntityFromJSONTyped(json, false);
}

export function ScheduleBlockEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleBlockEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'schedule': json['schedule'] == null ? undefined : json['schedule'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'startTime': json['startTime'] == null ? undefined : (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'participantId': json['participantId'] == null ? undefined : json['participantId'],
        'status': json['status'] == null ? undefined : json['status'],
        'originalBlockId': json['originalBlockId'] == null ? undefined : json['originalBlockId'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'linkedEntityType': json['linkedEntityType'] == null ? undefined : json['linkedEntityType'],
        'linkedEntityId': json['linkedEntityId'] == null ? undefined : json['linkedEntityId'],
        'lastExecutedAt': json['lastExecutedAt'] == null ? undefined : (new Date(json['lastExecutedAt'])),
        'executionCount': json['executionCount'] == null ? undefined : json['executionCount'],
        'lastError': json['lastError'] == null ? undefined : json['lastError'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'override': json['override'] == null ? undefined : json['override'],
    };
}

export function ScheduleBlockEntityToJSON(json: any): ScheduleBlockEntity {
    return ScheduleBlockEntityToJSONTyped(json, false);
}

export function ScheduleBlockEntityToJSONTyped(value?: ScheduleBlockEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'schedule': value['schedule'],
        'tenantId': value['tenantId'],
        'startTime': value['startTime'] == null ? undefined : ((value['startTime']).toISOString()),
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
        'participantId': value['participantId'],
        'status': value['status'],
        'originalBlockId': value['originalBlockId'],
        'notes': value['notes'],
        'metadata': value['metadata'],
        'linkedEntityType': value['linkedEntityType'],
        'linkedEntityId': value['linkedEntityId'],
        'lastExecutedAt': value['lastExecutedAt'] == null ? undefined : ((value['lastExecutedAt']).toISOString()),
        'executionCount': value['executionCount'],
        'lastError': value['lastError'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'override': value['override'],
    };
}

